(function () {
  var products = window.BF_PRODUCTS || [];
  var DIM_RE = /(\d+\.?\d*)[×xX](\d+\.?\d*)[×xX](\d+\.?\d*)\s*mm/;

  // --- Parse product data ---
  function parseDims(str) {
    var m = DIM_RE.exec(str);
    if (!m) return null;
    return { bore: parseFloat(m[1]), od: parseFloat(m[2]), w: parseFloat(m[3]) };
  }

  function extractBearingNumber(title) {
    var m = title.match(/^([A-Z0-9\-]+(?:ZZ|2RS|RS|RZ|2RZ)?)/i);
    return m ? m[1].toUpperCase() : '';
  }

  var indexed = products.map(function (p) {
    // Prefer structured spec metafields (custom.bore/outer_diameter/width_mm)
    // so any product auto-populates the finder regardless of title format.
    // Fall back to parsing dimensions out of the title / variant titles.
    var dims = null;
    if (p.bore != null && p.od != null && p.width != null) {
      dims = { bore: parseFloat(p.bore), od: parseFloat(p.od), w: parseFloat(p.width) };
    } else {
      dims = parseDims(p.title);
    }
    var variantDims = [];
    if (!dims) {
      p.variants.forEach(function (v) {
        var d = parseDims(v.title);
        if (d) variantDims.push({ variant: v, dims: d });
      });
    }
    var tags = typeof p.tags === 'string' ? p.tags.split(', ').map(function(t){ return t.trim(); }) : (p.tags || []);
    return Object.assign({}, p, {
      tags: tags,
      dims: dims,
      variantDims: variantDims,
      bearingNum: extractBearingNumber(p.title),
    });
  });

  // --- Wizard state ---
  var state = { path: null, bore: null, od: null, resultsBack: '0' };

  // --- Step transitions ---
  var wizard = document.getElementById('bf-wizard');

  function measureStep(step) {
    step.style.visibility = 'hidden';
    step.style.display = 'block';
    var h = step.scrollHeight;
    step.style.display = '';
    step.style.visibility = '';
    return h;
  }

  function goTo(stepId, direction) {
    direction = direction || 'forward';
    var current = wizard.querySelector('.bf-step--active');
    var next = wizard.querySelector('[data-step="' + stepId + '"]');
    if (!next || next === current) return;

    var outClass = direction === 'forward' ? 'bf-step--exit-left' : 'bf-step--exit-right';
    var inClass  = direction === 'forward' ? 'bf-step--enter-right' : 'bf-step--enter-left';

    // Animate wizard height to fit incoming step
    wizard.style.height = measureStep(next) + 'px';

    current.classList.add(outClass);
    next.classList.add(inClass);
    next.classList.add('bf-step--active');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        next.classList.remove(inClass);
        next.classList.add('bf-step--in');
      });
    });

    setTimeout(function () {
      current.classList.remove('bf-step--active', outClass);
      current.classList.remove('bf-step--in');
      next.classList.remove('bf-step--in');
      // Keep height pinned to the active step — steps are position:absolute,
      // so 'auto' would collapse the container to 0 and clip content.
      refreshHeight();
    }, 400);
  }

  // Recompute wizard height from the currently active step (call after its
  // inner content changes, e.g. suggestions/results appear).
  function refreshHeight() {
    var active = wizard.querySelector('.bf-step--active');
    if (active) wizard.style.height = active.scrollHeight + 'px';
  }

  // --- Path selection ---
  wizard.querySelectorAll('[data-path]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.path = btn.dataset.path;
      if (state.path === 'number') goTo('number-1');
      else if (state.path === 'dimensions') goTo('dim-1');
      else if (state.path === 'application') goTo('app-1');
    });
  });

  // --- Back buttons ---
  wizard.querySelectorAll('[data-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      goTo(btn.dataset.back, 'back');
    });
  });

  // --- BEARING NUMBER PATH ---
  var numInput = document.getElementById('bf-number-input');
  var suggestions = document.getElementById('bf-suggestions');

  function numberSearch(query) {
    query = query.trim().toUpperCase();
    if (!query) { suggestions.innerHTML = ''; refreshHeight(); return; }

    var matches = indexed.filter(function (p) {
      var inTitle = p.title.toUpperCase().indexOf(query) !== -1;
      var inTags  = p.tags.some(function (t) { return t.toUpperCase().indexOf(query) !== -1; });
      return inTitle || inTags;
    }).slice(0, 6);

    if (!matches.length) {
      suggestions.innerHTML = '<p class="bf-no-match">No matches — try a different number</p>';
      refreshHeight();
      return;
    }

    suggestions.innerHTML = matches.map(function (p) {
      return '<button class="bf-suggestion" data-handle="' + p.handle + '" data-url="' + p.url + '">' +
        '<img src="' + (p.image || '') + '" onerror="this.style.display=\'none\'" />' +
        '<div><strong>' + p.title + '</strong>' +
        '<span>' + p.priceFormatted + '</span></div></button>';
    }).join('');

    suggestions.querySelectorAll('.bf-suggestion').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showResults(indexed.filter(function(p){ return p.handle === btn.dataset.handle; }), 'number-1');
      });
    });
    refreshHeight();
  }

  if (numInput) {
    numInput.addEventListener('input', function () { numberSearch(numInput.value); });
  }

  // --- DIMENSIONS PATH ---
  document.getElementById('bf-bore-next').addEventListener('click', function () {
    var v = parseFloat(document.getElementById('bf-bore').value);
    if (!v) return;
    state.bore = v;
    showODHints(v);
    goTo('dim-2');
  });

  function showODHints(bore) {
    // no-op for now — could show common OD values for this bore
  }

  document.getElementById('bf-od-next').addEventListener('click', function () {
    var v = parseFloat(document.getElementById('bf-od').value);
    if (!v) return;
    state.od = v;
    goTo('dim-3');
  });

  document.getElementById('bf-width-search').addEventListener('click', function () {
    var w = parseFloat(document.getElementById('bf-width').value);
    if (!w) return;
    var bore = state.bore, od = state.od;
    var tol = 0.5;

    var matches = [];
    indexed.forEach(function (p) {
      if (p.dims) {
        if (Math.abs(p.dims.bore - bore) <= tol &&
            Math.abs(p.dims.od - od) <= tol &&
            Math.abs(p.dims.w - w) <= tol) {
          matches.push(p);
        }
      }
      p.variantDims.forEach(function (vd) {
        if (Math.abs(vd.dims.bore - bore) <= tol &&
            Math.abs(vd.dims.od - od) <= tol &&
            Math.abs(vd.dims.w - w) <= tol) {
          matches.push(Object.assign({}, p, { _matchedVariant: vd.variant }));
        }
      });
    });

    showResults(matches, 'dim-3');
  });

  // --- APPLICATION PATH ---
  var APP_TAGS = {
    bike:     ['Bike', 'Skateboard'],
    motor:    ['Motor'],
    fidget:   ['Fidget'],
    miniature:['Miniature', 'Miniture Bearing', 'Extra Thin', 'Extra Thin Bearing', 'Small Bearing'],
    needle:   [],
    general:  []
  };

  wizard.querySelectorAll('[data-app]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var app = btn.dataset.app;
      var matches;

      if (app === 'needle') {
        matches = indexed.filter(function (p) { return p.type === 'Needle Roller Bearings'; });
      } else if (app === 'general') {
        matches = indexed.filter(function (p) {
          return p.type === 'Deep Groove Ball Bearings' &&
            !p.tags.some(function(t){ return ['Bike','Motor','Fidget','Miniature','Miniture Bearing','Extra Thin','Skateboard','Small Bearing'].indexOf(t) !== -1; });
        });
      } else {
        var filter = APP_TAGS[app] || [];
        matches = indexed.filter(function (p) {
          return filter.some(function (tag) {
            return p.tags.indexOf(tag) !== -1;
          });
        });
      }

      showResults(matches, 'app-1');
    });
  });

  // --- RESULTS ---
  function showResults(matches, backStep) {
    state.resultsBack = backStep;
    document.getElementById('bf-results-back').dataset.back = backStep;

    var grid = document.getElementById('bf-results-grid');
    var none = document.getElementById('bf-no-results');
    var heading = document.getElementById('bf-results-heading');

    heading.textContent = matches.length + ' bearing' + (matches.length !== 1 ? 's' : '') + ' found';

    if (!matches.length) {
      grid.innerHTML = '';
      none.style.display = '';
    } else {
      none.style.display = 'none';
      grid.innerHTML = matches.map(function (p) {
        var mv = p._matchedVariant;
        var price = mv ? mv.priceFormatted : p.priceFormatted;
        var avail = mv ? mv.available : p.available;
        var stock = avail ? '<span class="bf-in-stock">● In stock</span>' : '<span class="bf-out-stock">● Out of stock</span>';
        return '<div class="bf-card">' +
          (p.image ? '<img class="bf-card__img" src="' + p.image + '" alt="" />' : '<div class="bf-card__img-placeholder"></div>') +
          '<div class="bf-card__body">' +
          '<p class="bf-card__title">' + p.title + '</p>' +
          '<p class="bf-card__price">' + price + '</p>' +
          stock +
          '</div>' +
          '<a class="bf-card__btn" href="' + p.url + '">View →</a>' +
          '</div>';
      }).join('');
    }

    goTo('results');
  }

  // back from results
  document.getElementById('bf-results-back').addEventListener('click', function () {
    goTo(state.resultsBack, 'back');
  });

  // Initialise wizard height to first step
  var firstStep = wizard.querySelector('.bf-step--active');
  if (firstStep) wizard.style.height = firstStep.scrollHeight + 'px';

})();
